module.exports = __webpack_public_path__ + "static/media/reset_success.25f115b9.svg";